import * as api from '../../../clients/incidents';

import {Action} from '@ngrx/store';

export const POST_INCIDENT_VORLAGE_ENTFERNEN_ADMIN = '[IncidentsModul] PostIncidentVorlageEntfernenAdmin laden';
export const POST_INCIDENT_VORLAGE_ENTFERNEN_ADMIN_AUSFUEHREN = '[IncidentsModul] PostIncidentVorlageEntfernenAdmin ausführen';
export const POST_INCIDENT_VORLAGE_ENTFERNEN_ADMIN_ERFOLGREICH = '[IncidentsModul] PostIncidentVorlageEntfernenAdmin laden erfolgreich';
export const POST_INCIDENT_VORLAGE_ENTFERNEN_ADMIN_FEHLER = '[IncidentsModul] PostIncidentVorlageEntfernenAdmin Ladefehler';
export const POST_INCIDENT_VORLAGE_ENTFERNEN_ADMIN_NICHT_AUSGEFUEHRT = '[IncidentsModul] PostIncidentVorlageEntfernenAdmin nicht ausgeführt (evtl. Offline)';


export class PostIncidentVorlageEntfernenAdminAction implements Action {
    readonly type = POST_INCIDENT_VORLAGE_ENTFERNEN_ADMIN;
        constructor(public incidentVorlageRequest: api.IncidentVorlageRequest, public optPayload: any = null) {}
    }
export class PostIncidentVorlageEntfernenAdminAusfuehrenAction implements Action {
    readonly type = POST_INCIDENT_VORLAGE_ENTFERNEN_ADMIN_AUSFUEHREN;
        constructor(public incidentVorlageRequest: api.IncidentVorlageRequest, public optPayload: any = null) {}
    }
export class PostIncidentVorlageEntfernenAdminErfolgreichAction implements Action {
    readonly type = POST_INCIDENT_VORLAGE_ENTFERNEN_ADMIN_ERFOLGREICH;
        constructor(public payload: api.IncidentVorlageIdentifier, public incidentVorlageRequest: api.IncidentVorlageRequest, public optPayload: any = null) {}
    }
export class PostIncidentVorlageEntfernenAdminFehlerAction implements Action {
    readonly type = POST_INCIDENT_VORLAGE_ENTFERNEN_ADMIN_FEHLER;
        constructor(public payload: any, public incidentVorlageRequest: api.IncidentVorlageRequest, public optPayload: any = null) {}
    }
export class PostIncidentVorlageEntfernenAdminNichtAusgefuehrtAction implements Action {
    readonly type = POST_INCIDENT_VORLAGE_ENTFERNEN_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type IncidentsCommandIncidentVorlageEntfernenAdminActions =
    PostIncidentVorlageEntfernenAdminAction
    | PostIncidentVorlageEntfernenAdminAusfuehrenAction
    | PostIncidentVorlageEntfernenAdminErfolgreichAction
    | PostIncidentVorlageEntfernenAdminFehlerAction
    | PostIncidentVorlageEntfernenAdminNichtAusgefuehrtAction
    ;
